<template>
  <div class="stepper" role="region" id="aria-live-region">
    <div class="line"  aria-live="assertive" :aria-label="ariaLabel"></div>
    <ol class="stepsBar" v-if="steps.length > 0">
      <li class="step" :class="['step' + (index+1), step]" v-for="(step, index) in steps" :key="step">
        <div aria-hidden="true" class="circle" :class="getIndexOfCurrentStep !== index ? 'hidden' : ''">
          {{ index + 1 }}
        </div>
        <div
          :key="isStepActive(index) ? 1 : 0"
          :aria-label="getSlotText('step' + (index + 1)) + ' Schritt ' + (index + 1) + ' von ' + steps.length"
          :role="'button'"
          :aria-disabled="!isStepActive(index)"
          :tabindex="isStepActive(index) ? 0 : -1"
          :class="['label', { active: isStepActive(index) }]"
          :aria-current="isCurrentStep(index) ? 'step' : null"
          @click="selectStep(step, index)"
          @keyup.enter="selectStep(step, index)">
          <slot :name="'step' + (index + 1)"></slot>
        </div>
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  name: 'StepsBar',
  data () {
    return {
      ariaLabel: ''
    }
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: String,
      required: true
    }
  },
  computed: {
    getIndexOfCurrentStep: function () {
      return this.steps.indexOf(this.currentStep)
    }
  },
  methods: {
    isStepActive (index) {
      return this.getIndexOfCurrentStep >= index
    },
    isCurrentStep (index) {
      return this.getIndexOfCurrentStep === index
    },
    selectStep (step, index) {
      // disable click event for steps with bigger index than current
      if (index > this.getIndexOfCurrentStep) {
        return
      }

      this.$emit('onStepClick', step)
    },
    updateAriaLabel () {
      this.ariaLabel = `Schritt-Indikator: Schritt ${
        this.getIndexOfCurrentStep + 1
      } von ${this.steps.length}`
    }
  },
  mounted () {
    this.updateAriaLabel()
  },
  watch: {
    currentStep () {
      this.updateAriaLabel()
    }
  }
}
</script>
